/**
 * Application entry point.
 *
 * This file includes `import`'s for all the components/directives used
 * by the HTML page and the controller to provide the configuration.
 */

import './desktop-bellevue7k.css';
import applyStyleShadowDom from './commons/applyStyleShadowDom.js';
import gmfDesktopCanvasStyles from './gmf-desktop-canvas-shadow.css?inline';
import gmfAuthFormStyle from './gmf-auth-form.css?inline';
import gmfAuthPanelStyle from './gmf-auth-panel.css?inline';
import toolButtonStyle from './tool-button-bellevue7k.css?inline';
applyStyleShadowDom(gmfDesktopCanvasStyles, toolButtonStyle, gmfAuthFormStyle, gmfAuthPanelStyle);

import angular from 'angular';

import {isEventUsingCtrlKey} from 'ngeo/utils';
import gmfControllersAbstractDesktopController, {
  AbstractDesktopController,
} from 'gmf/controllers/AbstractDesktopController';
import config from 'gmf/controllers/AbstractAppController.js';
import gmfContextualdataModule from 'ngeo/contextualdata/module';
import ngeoStatemanagerWfsPermalink from 'ngeo/statemanager/WfsPermalink';
import panels from 'gmfapi/store/panels';

import gr_mapfish3Base from './gr_mapfish3module.js';
import contextualDataHtmlTemplate from '../ngeo_custom_templates/contextualdata.html';
import queryWindowTemplate from '../ngeo_custom_templates/queryWindowComponent.html';
import layertreeTemplate from '../ngeo_custom_templates/layertree.html';
import webComponents from '../webcomponents/index';
import {initializeLocale, updateLanguageSwitcher} from './commons/localize.js';
import '../webcomponents/search-tooltip/search-tooltip.ts';
import {initTooltip} from '../webcomponents/search-tooltip/init-tooltip.ts';

import ngeoStreetviewModule from 'ngeo/streetview/module';

/**
 * @private
 */
class Controller extends AbstractDesktopController {
  closeToolPanel() {
    panels.closeToolPanel();
  }

  onKeydown(event) {
    if (event && isEventUsingCtrlKey(event) && event.key === 'p') {
      panels.openToolPanel('print');
      event.preventDefault();
    }
  }

  constructor($scope, $injector) {
    super($scope, $injector);
    updateLanguageSwitcher($scope, {lang: this.lang});
  }

  $onInit() {
    initializeLocale(this.lang).then(() => {
      document.querySelectorAll('search-tooltip').forEach((tooltip) => {
        (tooltip as HTMLElement & {requestUpdate?: () => void}).requestUpdate?.();
      });
    });
  }
}

/**
 * @hidden
 */
const gr_mapfish3Module = angular.module('Desktop', [
  gr_mapfish3Base.name,
  gmfControllersAbstractDesktopController.name,
  config.name,
  gmfContextualdataModule.name,
  ngeoStatemanagerWfsPermalink.name,
  webComponents.name,
  ngeoStreetviewModule.name,
]);

gr_mapfish3Module.value('gmfContextualdatacontentTemplateUrl', 'gmf/contextualdata');
gr_mapfish3Module.value('gmfDisplayquerywindowTemplateUrl', () => {
  return 'gmf/customquerywindow';
});
gr_mapfish3Module.value('gmfLayertreeNodeTemplateUrl', () => {
  return 'gmf/customlayertree';
});
gr_mapfish3Module.run(
  /**
   * @param {angular.ITemplateCacheService} $templateCache
   */
  [
    '$templateCache',
    ($templateCache) => {
      // @ts-ignore: webpack
      $templateCache.put('gmf/contextualdata', contextualDataHtmlTemplate);
      $templateCache.put('gmf/customquerywindow', queryWindowTemplate);
      $templateCache.put('gmf/customlayertree', layertreeTemplate);
    },
  ],
);

gr_mapfish3Module.controller('DesktopController', Controller);

gr_mapfish3Module.constant('obj', 'none');

initTooltip();

export default gr_mapfish3Module;
